// Tariff names come from the backend `tariffs` table in English only (see
// TariffSeeder) - this overrides the display name per language when we have a
// translation for the code, falling back to whatever the API sent otherwise
// (so a new tariff added later without a code change still shows something).
export function tariffDisplayName(tariff, t) {
  return t.rideForm?.tariffNames?.[tariff.code] || tariff.name;
}
